<template>
	<div>
		<h4 class="mb-3">{{ $t('import-results') }}</h4>
		<div class="card mb-3">
			<div class="card-body">
				<p class="text-success mb-1">{{ $t('rows-saved') }}: <strong>{{ importResults.saved_rows }}</strong></p>
				<p class="text-secondary mb-3">{{ $t('rows-skipped-no-student-match') }}: <strong>{{ importResults.skipped_rows }}</strong></p>

				<div v-if="importResults.created_columns && importResults.created_columns.length" class="mb-3">
					<p class="font-weight-bold mb-1">{{ $t('new-columns-created') }}</p>
					<ul class="mb-0">
						<li v-for="(col, i) in importResults.created_columns" :key="i">{{ col }}</li>
					</ul>
				</div>

				<b-button variant="primary" class="mt-2" @click="$emit('done')">
					{{ $t('done') }}
				</b-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		importResults: { type: Object, required: true },
	},
};
</script>
